var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_180_6643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.375 22.5C45.5788 22.5 50.625 17.4525 50.625 11.25C50.625 5.0475 45.5788 0 39.375 0C33.1713 0 28.125 5.0475 28.125 11.25C28.125 17.4525 33.1713 22.5 39.375 22.5ZM39.375 2.5C44.1987 2.5 48.125 6.425 48.125 11.25C48.125 16.075 44.1987 20 39.375 20C34.5512 20 30.625 16.075 30.625 11.25C30.625 6.425 34.5512 2.5 39.375 2.5Z",
    fill: "url(#paint0_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4537 64.3813C25.6787 63.9975 25.6825 63.5238 25.4637 63.1375L14.2137 43.1375C13.7712 42.35 12.4775 42.35 12.0362 43.1375L0.786202 63.1375C0.567452 63.525 0.571202 63.9975 0.796202 64.3813C1.0212 64.765 1.4312 65 1.87495 65H24.375C24.82 65 25.23 64.765 25.4537 64.3813ZM4.01245 62.5L13.125 46.3L22.2375 62.5H4.01245Z",
    fill: "url(#paint1_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.375 43.75C79.375 43.06 78.815 42.5 78.125 42.5H58.125C57.435 42.5 56.875 43.06 56.875 43.75V63.75C56.875 64.44 57.435 65 58.125 65H78.125C78.815 65 79.375 64.44 79.375 63.75V43.75ZM76.875 62.5H59.375V45H76.875V62.5Z",
    fill: "url(#paint2_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3749 71.2501C33.5711 71.2501 27.9424 69.5901 23.0936 66.4514L21.7336 68.5501C26.9886 71.9526 33.0886 73.7501 39.3749 73.7501C45.8999 73.7501 52.1936 71.8239 57.5761 68.1789L56.1749 66.1089C51.2074 69.4726 45.3986 71.2501 39.3749 71.2501Z",
    fill: "url(#paint3_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3525 40.0489L71.85 39.9514C71.3812 28.0164 64.4162 17.3289 53.675 12.0576L52.5737 14.3026C62.4887 19.1676 68.9187 29.0339 69.3525 40.0489Z",
    fill: "url(#paint4_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47 43.6514C9.4075 42.8626 9.375 42.0551 9.375 41.2501C9.375 29.7139 15.8125 19.3876 26.175 14.3026L25.075 12.0576C13.8487 17.5676 6.875 28.7526 6.875 41.2501C6.875 42.1214 6.90875 42.9951 6.9775 43.8501L9.47 43.6514Z",
    fill: "url(#paint5_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9912 9.11621L22.7588 10.8837L26.5088 7.13371C26.9975 6.64496 26.9975 5.85496 26.5088 5.36621L22.7588 1.61621L20.9912 3.38371L22.6075 4.99996H14.375V7.49996H22.6075L20.9912 9.11621Z",
    fill: "url(#paint6_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.375 28.75C74.695 28.75 75.015 28.6275 75.2587 28.3838L79.0087 24.6338L77.2412 22.8662L75.625 24.4825V16.25H73.125V24.4825L71.5087 22.8662L69.7412 24.6338L73.4912 28.3838C73.735 28.6275 74.055 28.75 74.375 28.75Z",
    fill: "url(#paint7_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2412 67.8661L8.49121 71.6161L10.2587 73.3836L11.875 71.7673V79.9998H14.375V71.7673L15.9912 73.3836L17.7587 71.6161L14.0087 67.8661C13.5212 67.3773 12.73 67.3773 12.2412 67.8661Z",
    fill: "url(#paint8_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6249 40.0001C50.6249 35.9963 48.4699 32.2626 45.0012 30.2563L43.7487 32.4201C46.4474 33.9813 48.1249 36.8851 48.1249 40.0001C48.1249 44.0763 45.3174 47.5014 41.5387 48.4688L42.9937 45.5601L40.7574 44.4413L38.2574 49.4413C38.0174 49.9226 38.1112 50.5038 38.4924 50.8838L42.2424 54.6338L44.0099 52.8663L42.0574 50.9138C46.9674 49.7063 50.6249 45.2776 50.6249 40.0001Z",
    fill: "url(#paint9_linear_180_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7525 49.7462L35.0025 47.5825C32.3025 46.0212 30.625 43.1162 30.625 40C30.625 35.9237 33.4325 32.4987 37.2112 31.5312L35.7562 34.44L37.9925 35.5587L40.4925 30.5587C40.7325 30.0775 40.6387 29.4962 40.2575 29.1162L36.5075 25.3662L34.74 27.1337L36.6925 29.0862C31.7838 30.2937 28.125 34.7225 28.125 40C28.125 44.0062 30.2813 47.74 33.7525 49.7462Z",
    fill: "url(#paint10_linear_180_6643)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6643",
    x1: 28.1251,
    y1: 11.2502,
    x2: 50.625,
    y2: 11.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6643",
    x1: 0.62488,
    y1: 53.7736,
    x2: 25.6251,
    y2: 53.7736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6643",
    x1: 56.8751,
    y1: 53.7502,
    x2: 79.375,
    y2: 53.7502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_6643",
    x1: 21.7338,
    y1: 69.9296,
    x2: 57.5761,
    y2: 69.9296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_6643",
    x1: 52.5738,
    y1: 26.0535,
    x2: 71.85,
    y2: 26.0535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_180_6643",
    x1: 6.8751,
    y1: 27.9541,
    x2: 26.175,
    y2: 27.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_180_6643",
    x1: 14.3751,
    y1: 6.25003,
    x2: 26.8753,
    y2: 6.25003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_180_6643",
    x1: 69.7413,
    y1: 22.5001,
    x2: 79.0087,
    y2: 22.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_180_6643",
    x1: 8.49126,
    y1: 73.7498,
    x2: 17.7587,
    y2: 73.7498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_180_6643",
    x1: 38.1258,
    y1: 42.4453,
    x2: 50.6249,
    y2: 42.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_180_6643",
    x1: 28.1251,
    y1: 37.5564,
    x2: 40.6242,
    y2: 37.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_6643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.75,
    height: 80,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.71a9716d39423c01e6ca44a6e48449b3.svg";
export { ForwardRef as ReactComponent };